import { graphql } from 'react-relay';
import { VariablesOf } from 'relay-runtime';

import { useAsyncMutation } from 'shared-lib';

import { UseUseImpersonationTokenMutation } from './__generated__/UseUseImpersonationTokenMutation.graphql';

const mutationDef = graphql`
  mutation UseUseImpersonationTokenMutation(
    $input: IdentityUseImpersonationTokenInput!
  ) {
    result: identityUseImpersonationToken(input: $input) {
      impersonationUseTokenPayload {
        code
        model {
          __typename
          cursor
          node {
            id
            tokenId
            hasBeenUsed
            isDeleted
            token
            createdAt
            createdById
            createdByAccountType
            updatedAt
            updatedById
            updatedByAccountType
          }
        }
      }

      userErrors {
        ... on ElevateUserError {
          name: __typename
          code
          message
        }
      }
    }
  }
`;

export function useUseImpersonationToken(): [
  (
    x: VariablesOf<UseUseImpersonationTokenMutation>,
  ) => Promise<UseUseImpersonationTokenMutation['response']>,
  boolean,
] {
  const [commit, isBusy] =
    useAsyncMutation<UseUseImpersonationTokenMutation>(mutationDef);
  return [commit, isBusy];
}
